export default __webpack_public_path__ + "static/media/amine-additives.22621751.png";